// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Service-provider dashboard. Root: .sp-dashboard */
.sp-dashboard {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
}

.sp-dashboard--loading {
  align-items: center;
  justify-content: center;
  min-height: 50vh;
}

.sp-dashboard__row {
  margin: 0;
}

/* ── Hero ── */
.sp-dashboard__hero {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
  padding: var(--ds-space-5) var(--ds-space-4) var(--ds-space-4);
  border-radius: var(--ds-radius-xl);
  color: #fff;
  background:
    radial-gradient(120% 140% at 100% 0%, rgba(79, 179, 211, 0.55) 0%, transparent 55%),
    linear-gradient(135deg, var(--ds-brand-deep) 0%, var(--ds-brand-dark) 55%, var(--ds-brand) 100%);
  box-shadow: var(--ds-shadow-md);
}

[dir="rtl"] .sp-dashboard__hero {
  background:
    radial-gradient(120% 140% at 0% 0%, rgba(79, 179, 211, 0.55) 0%, transparent 55%),
    linear-gradient(225deg, var(--ds-brand-deep) 0%, var(--ds-brand-dark) 55%, var(--ds-brand) 100%);
}

/* Logo-like ring decoration */
.sp-dashboard__hero::after {
  content: "";
  position: absolute;
  inset-inline-end: -60px;
  bottom: -90px;
  width: 240px;
  height: 240px;
  border: 28px solid rgba(255, 255, 255, 0.07);
  border-radius: 48px;
  transform: rotate(45deg);
  pointer-events: none;
}

.sp-dashboard__hero-text {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.sp-dashboard__date {
  display: block;
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.8;
  margin-bottom: 4px;
}

.sp-dashboard__hero h2 {
  margin: 0;
  color: #fff;
  font-size: 1.4rem;
  font-weight: 800;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.sp-dashboard__hero p {
  margin: 6px 0 0;
  opacity: 0.85;
  font-size: 0.9rem;
}

/* Attention chips: 2×2 on phones, one row on wide screens */
.sp-dashboard__chips {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--ds-space-2);
}

.sp-dashboard__chip {
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-areas:
    "icon value go"
    "label label label";
  align-items: center;
  gap: 2px 8px;
  min-height: 72px;
  padding: 10px 12px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: var(--ds-radius-lg);
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(6px);
  color: #fff;
  font: inherit;
  text-align: start;
  cursor: pointer;
  transition: background-color 0.15s;
}

.sp-dashboard__chip:hover,
.sp-dashboard__chip:focus-visible {
  background: rgba(255, 255, 255, 0.18);
}

.sp-dashboard__chip-icon {
  grid-area: icon;
  display: inline-flex;
  font-size: 16px;
  opacity: 0.85;
}

.sp-dashboard__chip-value {
  grid-area: value;
  font-family: var(--ds-font-display);
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.sp-dashboard__chip-go {
  grid-area: go;
  font-size: 10px;
  opacity: 0.6;
}

.sp-dashboard__chip-label {
  grid-area: label;
  font-size: 0.75rem;
  opacity: 0.85;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.sp-dashboard__chip.is-alert {
  background: rgba(255, 255, 255, 0.95);
  border-color: transparent;
  color: var(--ds-danger);
}

.sp-dashboard__chip.is-alert .sp-dashboard__chip-label {
  color: var(--ds-text-2);
  opacity: 1;
}

/* ── KPI tiles ── */
.sp-dashboard .sp-dashboard__kpi {
  height: 100%;
  --kpi-fg: var(--ds-brand);
  --kpi-bg: var(--ds-brand-50);
}

.sp-dashboard .sp-dashboard__kpi--green {
  --kpi-fg: var(--ds-success);
  --kpi-bg: var(--ds-success-bg);
}

.sp-dashboard .sp-dashboard__kpi--violet {
  --kpi-fg: #5a48b8;
  --kpi-bg: #efecfb;
}

.sp-dashboard .sp-dashboard__kpi--amber {
  --kpi-fg: var(--ds-warning);
  --kpi-bg: var(--ds-warning-bg);
}

.sp-dashboard .sp-dashboard__kpi .ant-card-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: var(--ds-space-4);
}

.sp-dashboard .sp-dashboard__kpi:focus-visible {
  outline: none;
  box-shadow: var(--ds-focus-ring);
}

.sp-dashboard__kpi-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-bottom: var(--ds-space-2);
  border-radius: 11px;
  font-size: 18px;
  color: var(--kpi-fg);
  background: var(--kpi-bg);
}

.sp-dashboard__kpi-title {
  color: var(--ds-text-2);
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.sp-dashboard__kpi-value {
  color: var(--ds-heading);
  font-family: var(--ds-font-display);
  font-size: 1.5rem;
  font-weight: 800;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.sp-dashboard__money {
  font-size: 0.9em;
}

.sp-dashboard__kpi-sub {
  font-size: 0.75rem;
  overflow-wrap: anywhere;
}

.sp-dashboard__up {
  color: var(--ds-success);
  font-weight: 600;
}

.sp-dashboard__muted {
  color: var(--ds-text-2);
}

/* ── Charts and lists ── */
.sp-dashboard .sp-dashboard__chart,
.sp-dashboard .sp-dashboard__list {
  height: 100%;
}

.sp-dashboard .sp-dashboard__chart .ant-card-body {
  padding-inline: var(--ds-space-2);
  overflow: hidden;
}

.sp-dashboard__chart-empty {
  padding-block: var(--ds-space-6);
}

.sp-dashboard .sp-dashboard__list .ant-card-body {
  padding: 0;
}

.sp-dashboard .sp-dashboard__list .ant-table-wrapper .ant-table {
  border: 0;
  border-radius: 0 0 var(--ds-radius-lg) var(--ds-radius-lg);
  box-shadow: none;
}

.sp-dashboard .sp-dashboard__list .rt-cards {
  padding: var(--ds-space-3);
}

.sp-dashboard .sp-dashboard__list .rt-card {
  box-shadow: none;
  background: var(--ds-surface-2);
}

.sp-dashboard .sp-dashboard__progress {
  min-width: 120px;
  margin: 0;
}

/* ── Larger screens ── */
@media (min-width: 768px) {
  .sp-dashboard {
    gap: var(--ds-space-5);
  }

  .sp-dashboard__hero {
    padding: var(--ds-space-6);
  }

  .sp-dashboard__hero h2 {
    font-size: 1.75rem;
  }

  .sp-dashboard__chips {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sp-dashboard .sp-dashboard__kpi .ant-card-body {
    padding: var(--ds-space-5);
  }

  .sp-dashboard__kpi-icon {
    width: 42px;
    height: 42px;
    font-size: 20px;
  }

  .sp-dashboard__kpi-title {
    font-size: 0.875rem;
  }

  .sp-dashboard__kpi-value {
    font-size: 1.85rem;
  }
}

@media (min-width: 1200px) {
  .sp-dashboard__hero {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: var(--ds-space-8);
  }

  .sp-dashboard__chips {
    flex: 0 1 720px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,8DAA8D;EAC9D,kCAAkC;EAClC,WAAW;EACX;;oGAEkG;EAClG,+BAA+B;AACjC;;AAEA;EACE;;oGAEkG;AACpG;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC;;uBAEqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,oCAAoC;EACpC,0BAA0B;EAC1B,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;;EAEE,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,0DAA0D;EAC1D,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Service-provider dashboard. Root: .sp-dashboard */\n.sp-dashboard {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-4);\n}\n\n.sp-dashboard--loading {\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n}\n\n.sp-dashboard__row {\n  margin: 0;\n}\n\n/* ── Hero ── */\n.sp-dashboard__hero {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-4);\n  padding: var(--ds-space-5) var(--ds-space-4) var(--ds-space-4);\n  border-radius: var(--ds-radius-xl);\n  color: #fff;\n  background:\n    radial-gradient(120% 140% at 100% 0%, rgba(79, 179, 211, 0.55) 0%, transparent 55%),\n    linear-gradient(135deg, var(--ds-brand-deep) 0%, var(--ds-brand-dark) 55%, var(--ds-brand) 100%);\n  box-shadow: var(--ds-shadow-md);\n}\n\n[dir=\"rtl\"] .sp-dashboard__hero {\n  background:\n    radial-gradient(120% 140% at 0% 0%, rgba(79, 179, 211, 0.55) 0%, transparent 55%),\n    linear-gradient(225deg, var(--ds-brand-deep) 0%, var(--ds-brand-dark) 55%, var(--ds-brand) 100%);\n}\n\n/* Logo-like ring decoration */\n.sp-dashboard__hero::after {\n  content: \"\";\n  position: absolute;\n  inset-inline-end: -60px;\n  bottom: -90px;\n  width: 240px;\n  height: 240px;\n  border: 28px solid rgba(255, 255, 255, 0.07);\n  border-radius: 48px;\n  transform: rotate(45deg);\n  pointer-events: none;\n}\n\n.sp-dashboard__hero-text {\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n}\n\n.sp-dashboard__date {\n  display: block;\n  font-size: 0.8rem;\n  font-weight: 500;\n  opacity: 0.8;\n  margin-bottom: 4px;\n}\n\n.sp-dashboard__hero h2 {\n  margin: 0;\n  color: #fff;\n  font-size: 1.4rem;\n  font-weight: 800;\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n}\n\n.sp-dashboard__hero p {\n  margin: 6px 0 0;\n  opacity: 0.85;\n  font-size: 0.9rem;\n}\n\n/* Attention chips: 2×2 on phones, one row on wide screens */\n.sp-dashboard__chips {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--ds-space-2);\n}\n\n.sp-dashboard__chip {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  grid-template-areas:\n    \"icon value go\"\n    \"label label label\";\n  align-items: center;\n  gap: 2px 8px;\n  min-height: 72px;\n  padding: 10px 12px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: var(--ds-radius-lg);\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(6px);\n  color: #fff;\n  font: inherit;\n  text-align: start;\n  cursor: pointer;\n  transition: background-color 0.15s;\n}\n\n.sp-dashboard__chip:hover,\n.sp-dashboard__chip:focus-visible {\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.sp-dashboard__chip-icon {\n  grid-area: icon;\n  display: inline-flex;\n  font-size: 16px;\n  opacity: 0.85;\n}\n\n.sp-dashboard__chip-value {\n  grid-area: value;\n  font-family: var(--ds-font-display);\n  font-size: 1.35rem;\n  font-weight: 800;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n\n.sp-dashboard__chip-go {\n  grid-area: go;\n  font-size: 10px;\n  opacity: 0.6;\n}\n\n.sp-dashboard__chip-label {\n  grid-area: label;\n  font-size: 0.75rem;\n  opacity: 0.85;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n.sp-dashboard__chip.is-alert {\n  background: rgba(255, 255, 255, 0.95);\n  border-color: transparent;\n  color: var(--ds-danger);\n}\n\n.sp-dashboard__chip.is-alert .sp-dashboard__chip-label {\n  color: var(--ds-text-2);\n  opacity: 1;\n}\n\n/* ── KPI tiles ── */\n.sp-dashboard .sp-dashboard__kpi {\n  height: 100%;\n  --kpi-fg: var(--ds-brand);\n  --kpi-bg: var(--ds-brand-50);\n}\n\n.sp-dashboard .sp-dashboard__kpi--green {\n  --kpi-fg: var(--ds-success);\n  --kpi-bg: var(--ds-success-bg);\n}\n\n.sp-dashboard .sp-dashboard__kpi--violet {\n  --kpi-fg: #5a48b8;\n  --kpi-bg: #efecfb;\n}\n\n.sp-dashboard .sp-dashboard__kpi--amber {\n  --kpi-fg: var(--ds-warning);\n  --kpi-bg: var(--ds-warning-bg);\n}\n\n.sp-dashboard .sp-dashboard__kpi .ant-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: var(--ds-space-4);\n}\n\n.sp-dashboard .sp-dashboard__kpi:focus-visible {\n  outline: none;\n  box-shadow: var(--ds-focus-ring);\n}\n\n.sp-dashboard__kpi-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  margin-bottom: var(--ds-space-2);\n  border-radius: 11px;\n  font-size: 18px;\n  color: var(--kpi-fg);\n  background: var(--kpi-bg);\n}\n\n.sp-dashboard__kpi-title {\n  color: var(--ds-text-2);\n  font-size: 0.8rem;\n  font-weight: 500;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n}\n\n.sp-dashboard__kpi-value {\n  color: var(--ds-heading);\n  font-family: var(--ds-font-display);\n  font-size: 1.5rem;\n  font-weight: 800;\n  line-height: 1.2;\n  font-variant-numeric: tabular-nums;\n  overflow-wrap: anywhere;\n}\n\n.sp-dashboard__money {\n  font-size: 0.9em;\n}\n\n.sp-dashboard__kpi-sub {\n  font-size: 0.75rem;\n  overflow-wrap: anywhere;\n}\n\n.sp-dashboard__up {\n  color: var(--ds-success);\n  font-weight: 600;\n}\n\n.sp-dashboard__muted {\n  color: var(--ds-text-2);\n}\n\n/* ── Charts and lists ── */\n.sp-dashboard .sp-dashboard__chart,\n.sp-dashboard .sp-dashboard__list {\n  height: 100%;\n}\n\n.sp-dashboard .sp-dashboard__chart .ant-card-body {\n  padding-inline: var(--ds-space-2);\n  overflow: hidden;\n}\n\n.sp-dashboard__chart-empty {\n  padding-block: var(--ds-space-6);\n}\n\n.sp-dashboard .sp-dashboard__list .ant-card-body {\n  padding: 0;\n}\n\n.sp-dashboard .sp-dashboard__list .ant-table-wrapper .ant-table {\n  border: 0;\n  border-radius: 0 0 var(--ds-radius-lg) var(--ds-radius-lg);\n  box-shadow: none;\n}\n\n.sp-dashboard .sp-dashboard__list .rt-cards {\n  padding: var(--ds-space-3);\n}\n\n.sp-dashboard .sp-dashboard__list .rt-card {\n  box-shadow: none;\n  background: var(--ds-surface-2);\n}\n\n.sp-dashboard .sp-dashboard__progress {\n  min-width: 120px;\n  margin: 0;\n}\n\n/* ── Larger screens ── */\n@media (min-width: 768px) {\n  .sp-dashboard {\n    gap: var(--ds-space-5);\n  }\n\n  .sp-dashboard__hero {\n    padding: var(--ds-space-6);\n  }\n\n  .sp-dashboard__hero h2 {\n    font-size: 1.75rem;\n  }\n\n  .sp-dashboard__chips {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .sp-dashboard .sp-dashboard__kpi .ant-card-body {\n    padding: var(--ds-space-5);\n  }\n\n  .sp-dashboard__kpi-icon {\n    width: 42px;\n    height: 42px;\n    font-size: 20px;\n  }\n\n  .sp-dashboard__kpi-title {\n    font-size: 0.875rem;\n  }\n\n  .sp-dashboard__kpi-value {\n    font-size: 1.85rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .sp-dashboard__hero {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--ds-space-8);\n  }\n\n  .sp-dashboard__chips {\n    flex: 0 1 720px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
